module.exports = __webpack_public_path__ + "static/media/loading.d5ff0735.svg";